/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_8Inputs */

const es_chat_suggestions_welcome_8 = /** @type {(inputs: Chat_Suggestions_Welcome_8Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Qué información estás buscando hoy, ${i?.name}?`)
};

const en_chat_suggestions_welcome_8 = /** @type {(inputs: Chat_Suggestions_Welcome_8Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What information are you looking for today, ${i?.name}?`)
};

/**
* | output |
* | --- |
* | "What information are you looking for today, {name}?" |
*
* @param {Chat_Suggestions_Welcome_8Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_8 = /** @type {((inputs: Chat_Suggestions_Welcome_8Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_8Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_8(inputs)
	return en_chat_suggestions_welcome_8(inputs)
});
export { chat_suggestions_welcome_8 as "chat.suggestions.welcome_8" }